import type { InviteByEmailData, ShareAuthCheckData, ShareLinkResponse } from '../types';

export interface ShareService {
    getShareId(data: ShareAuthCheckData): Promise<ShareLinkResponse>;
    inviteByEmail(data: InviteByEmailData): Promise<boolean>;
}

export const ShareService = Symbol('ShareService');
